import { render } from "./PopupSelectie.vue?vue&type=template&id=438bdb2f&scoped=true"
import script from "./PopupSelectie.vue?vue&type=script&lang=js"
export * from "./PopupSelectie.vue?vue&type=script&lang=js"

import "./PopupSelectie.vue?vue&type=style&index=0&id=438bdb2f&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438bdb2f"]])

export default __exports__